import React, { useMemo } from 'react';

import { useAppTakeoverPdp } from 'components/app-takeover/use-app-takeover';
import SodiumFlag from 'components/product-detail-v2/nutrition-information/sodium-flag';
import { OrderSummary } from 'components/product-detail-v2/order-summary';
import { PriceAndCalories } from 'components/product-detail-v2/price-and-calories';
import { ProductInformationContainer } from 'components/product-detail-v2/product-overview/styled';
import { useProductWizardContext } from 'state/product-wizard-v2';
import { hasExcessSodium } from 'utils/menu/sodium';
import { getSelectionsFromMenuData } from 'utils/wizard';

import { Container, ProductTitle, Wrapper } from './styled';

const sodiumFlagIcon = <SodiumFlag size={{ base: '20px', md: '26px' }} />;

export const OrderSummaryPanel = () => {
  const { menuObject, selectedProduct, userSelections } = useProductWizardContext();
  const { fontFamily: takeoverFontFamily, summaryPageTextColor } = useAppTakeoverPdp(
    menuObject?._id
  );

  const isOverSodiumLimit = useMemo(() => {
    const { comboSlotSelections, modifierSelections } = getSelectionsFromMenuData({
      data: menuObject,
      pickerSelectionOverrides: userSelections.pickerAspects,
    });

    return hasExcessSodium({
      selectedOpt: selectedProduct,
      comboSlotSelections,
      modifierSelections,
    });
  }, [menuObject, selectedProduct, userSelections.pickerAspects]);

  return (
    <Wrapper testID="order-review">
      <Container>
        <ProductTitle fontFamily={takeoverFontFamily} color={summaryPageTextColor}>
          {selectedProduct?.name?.locale ?? ''}
        </ProductTitle>
        <ProductInformationContainer>
          <PriceAndCalories
            fontColorOverride={summaryPageTextColor}
            productPriceConditions={{
              shouldIncludeModifications: true,
              shouldIncludeQuantity: false,
            }}
            icon={isOverSodiumLimit ? sodiumFlagIcon : undefined}
          />
        </ProductInformationContainer>
      </Container>
      <OrderSummary />
    </Wrapper>
  );
};
